export const TIER_COLORS = {
  Elite: "#39FF14",
  "Very Fast": "#00F0FF",
  Fast: "#00F0FF",
  Developing: "#A1A1AA",
  Beginner: "#F59E0B",
};

export function tierColor(tier) {
  return TIER_COLORS[tier] || "#A1A1AA";
}

export function msColor(ms) {
  if (ms < 200) return "#39FF14";
  if (ms < 250) return "#00F0FF";
  if (ms < 320) return "#A1A1AA";
  if (ms < 400) return "#F59E0B";
  return "#EF4444";
}

export const COUNTRIES = [
  { code: "US", name: "United States", flag: "🇺🇸" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧" },
  { code: "CA", name: "Canada", flag: "🇨🇦" },
  { code: "AU", name: "Australia", flag: "🇦🇺" },
  { code: "DE", name: "Germany", flag: "🇩🇪" },
  { code: "FR", name: "France", flag: "🇫🇷" },
  { code: "IN", name: "India", flag: "🇮🇳" },
  { code: "BR", name: "Brazil", flag: "🇧🇷" },
  { code: "JP", name: "Japan", flag: "🇯🇵" },
  { code: "KR", name: "South Korea", flag: "🇰🇷" },
  { code: "NL", name: "Netherlands", flag: "🇳🇱" },
  { code: "SE", name: "Sweden", flag: "🇸🇪" },
  { code: "ES", name: "Spain", flag: "🇪🇸" },
  { code: "IT", name: "Italy", flag: "🇮🇹" },
  { code: "MX", name: "Mexico", flag: "🇲🇽" },
];

export function countryFlag(code) {
  const c = COUNTRIES.find((x) => x.code === code);
  return c ? c.flag : "🏳️";
}
